import React from 'react';
import SectionTitle from '../../components/SectionTitle/';
import Paragraph from '../../components/Paragraph/';
import styles from './About.css';
import VideoTabs from '../VideoTabs/';
import { gcpURL } from '../../lib/utils';

const iconAbout = `${gcpURL}/static/ic-about.svg`;

const About = () => (
  <section className={`${styles.about}`}>
    <div className="container">
      <SectionTitle icon={iconAbout} title="關於金羽"/>
      <Paragraph>
        金羽獎（Golden Feather Awards，GFA）發想自華人世界傳奇人物－關羽。民間故事中義氣與才氣兼具的代表，與台灣直播社群創辦人 黃立成處世理念相當符合；『羽』同時也有著展翅飛翔之奧義。
      </Paragraph>
      <Paragraph>
        籌辦金羽獎的目的，是以迎接嶄新娛樂的態度，推廣優質直播內容，更鼓勵來自世界各地展現個人才藝及特色，用心經營、鞏固網路娛樂產業文化的主播，將其各個面貌 – 作為新生能量及獨創文化，點石成金、羽化登仙、展翅飛翔。金羽獎將為華人直播娛樂工作者進行評審及精彩回顧，以提高社會對直播新興產業的關注，讓華人直播更加精彩可期。
      </Paragraph>
    </div>
    <VideoTabs />
  </section>
);

export default About;



// WEBPACK FOOTER //
// ./src/sections/About/index.js